module.exports = __webpack_public_path__ + "img/sd.54aa0c7f.svg";